import React from "react";
import Container from "../../components/Container";
import Heading from "../../components/Heading";
import API from "../../services/API";
import ContentForYouForm from "../ContentForYouDaily/components/ContentForYouForm";
import ContentForYouTable from "../ContentForYouDaily/components/ContentForYouTable";
import {Alert} from "react-bootstrap";

class ContentForYouHourly extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            error: "",
            affidValues: [],
            sourceValues: [],
            report: {
                params: [],
                report: [],
                total: {}
            }
        };

        this.handleSubmitButton = this.handleSubmitButton.bind(this);
    }

    handleSubmitButton(filters, type) {
        this.setState({ isLoading: true })

        if(type === "filters") {
            Promise.all([
                API.ContentForYou.affids(filters, 'hourly'),
                API.ContentForYou.sources(filters, 'hourly'),
            ])
                .then(([affidValues, sourceValues]) => this.setState({ isLoading: false, affidValues, sourceValues }))
        } else {
            API.ContentForYou.get(filters, 'hourly')
                .then((report) => {
                    if (report.error) this.setState({ isLoading: false, error: report.error });
                    else this.setState({ report, isLoading: false })
                })
                .catch((err) => console.log(err))
        }
    }

    render() {
        const groupBy = [
            { name: 'date', title: 'Hour' },
            { name: 'source', title: 'Source' },
            { name: 'affid', title: 'Affid' },
            { name: 'country', title: 'Country' },
        ]

        return (
            <Container loading={this.state.isLoading}>
                <Heading title="ContentForYou Hourly"/>

                {this.state.error && <Alert bsStyle={"danger"}>{this.state.error}</Alert>}

                <ContentForYouForm groupBy={groupBy} type={'hourly'} handleSubmitButton={this.handleSubmitButton} {...this.state} />

                <ContentForYouTable {...this.state} />
            </Container>
        )
    }
}

export default ContentForYouHourly;


// WEBPACK FOOTER //
// ./src/scenes/ContentForYouHourly/index.js